var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _path21, _g2, _path22, _g3, _path23, _path24, _path25, _path26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPaymentCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5383 2.7207H2.06013C1.3757 2.7207 0.800781 3.29584 0.800781 3.98052V17.3456C0.800781 18.0576 1.3757 18.6054 2.06013 18.6054H22.5383C23.2501 18.6054 23.7976 18.0303 23.7976 17.3456V3.98052C23.7976 3.29584 23.2227 2.7207 22.5383 2.7207Z",
    fill: "#A2B5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.609 9.29297H2.71875V13.4011H21.609V9.29297Z",
    fill: "#CAEAFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7976 6.00781H0.800781V10.1159H23.7976V6.00781Z",
    fill: "#03134F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5383 2.7207H2.06013C1.3757 2.7207 0.800781 3.29584 0.800781 3.98052V17.3456C0.800781 18.0576 1.3757 18.6054 2.06013 18.6054H22.5383C23.2501 18.6054 23.7976 18.0303 23.7976 17.3456V3.98052C23.7976 3.29584 23.2227 2.7207 22.5383 2.7207Z",
    stroke: "#03134F",
    strokeWidth: 0.342342,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.99219 15.0449H9.56271",
    stroke: "#03134F",
    strokeWidth: 0.342342,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.99219 16.1406H9.56271",
    stroke: "#03134F",
    strokeWidth: 0.342342,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.45243 12.0332C8.00144 12.0332 6.82422 13.2109 6.82422 14.6624V18.6062H22.5387C23.2505 18.6062 23.7981 18.031 23.7981 17.3464V12.0332H9.45243Z",
    fill: "#03134F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9289 13.4023H9.45076C8.73895 13.4023 8.19141 13.9775 8.19141 14.6622V28.0272C8.19141 28.7393 8.76633 29.287 9.45076 29.287H29.9289C30.6407 29.287 31.1882 28.7119 31.1882 28.0272V14.6622C31.1882 13.9775 30.6133 13.4023 29.9289 13.4023Z",
    fill: "#C51F2A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9159 21.3447C29.7099 21.3447 30.4764 21.2352 31.1883 21.0161V17.3188C30.5312 17.7022 29.7373 17.9213 28.9159 17.9213C26.3972 17.9213 24.3713 15.8946 24.3713 13.375H20.9766C20.9766 17.7844 24.5356 21.3447 28.9159 21.3447Z",
    fill: "#F3877E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9289 13.4023H9.45076C8.73895 13.4023 8.19141 13.9775 8.19141 14.6622V28.0272C8.19141 28.7393 8.76633 29.287 9.45076 29.287H29.9289C30.6407 29.287 31.1882 28.7119 31.1882 28.0272V14.6622C31.1882 13.9775 30.6133 13.4023 29.9289 13.4023Z",
    stroke: "#03134F",
    strokeWidth: 0.342342,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5589 22.9877H10.7664C10.4105 22.9877 10.1094 22.6864 10.1094 22.3304V20.3311C10.1094 19.9751 10.4105 19.6738 10.7664 19.6738H13.5863C13.9422 19.6738 14.2433 19.9751 14.2433 20.3311V22.3304C14.216 22.6864 13.9148 22.9877 13.5589 22.9877Z",
    fill: "#FFC408"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5589 22.9877H10.7664C10.4105 22.9877 10.1094 22.6864 10.1094 22.3304V20.3311C10.1094 19.9751 10.4105 19.6738 10.7664 19.6738H13.5863C13.9422 19.6738 14.2433 19.9751 14.2433 20.3311V22.3304C14.216 22.6864 13.9148 22.9877 13.5589 22.9877Z",
    stroke: "#03134F",
    strokeWidth: 0.342342,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3828 24.3574H13.9418",
    stroke: "#03134F",
    strokeWidth: 0.342342,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3828 25.4531H15.8582",
    stroke: "white",
    strokeWidth: 0.342342,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3828 26.8223H12.8468",
    stroke: "white",
    strokeWidth: 0.342342,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2266 25.4531H19.143",
    stroke: "white",
    strokeWidth: 0.342342,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0352 24.3574H18.868",
    stroke: "#03134F",
    strokeWidth: 0.342342,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2383 24.3574H23.5235",
    stroke: "#03134F",
    strokeWidth: 0.342342,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8945 24.3574H28.7273",
    stroke: "#03134F",
    strokeWidth: 0.342342,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_789_29033",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 19,
    width: 5,
    height: 4
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5589 22.9877H10.7664C10.4105 22.9877 10.1094 22.6864 10.1094 22.3304V20.3311C10.1094 19.9751 10.4105 19.6738 10.7664 19.6738H13.5863C13.9422 19.6738 14.2433 19.9751 14.2433 20.3311V22.3304C14.216 22.6864 13.9148 22.9877 13.5589 22.9877Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_789_29033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8454 19.4277H11.4766V23.262H12.8454V19.4277Z",
    stroke: "#03134F",
    strokeWidth: 0.342342,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_789_29033",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 19,
    width: 5,
    height: 4
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5589 22.9877H10.7664C10.4105 22.9877 10.1094 22.6864 10.1094 22.3304V20.3311C10.1094 19.9751 10.4105 19.6738 10.7664 19.6738H13.5863C13.9422 19.6738 14.2433 19.9751 14.2433 20.3311V22.3304C14.216 22.6864 13.9148 22.9877 13.5589 22.9877Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_789_29033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8477 21.3438H14.2165",
    stroke: "#03134F",
    strokeWidth: 0.342342,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_789_29033",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 19,
    width: 5,
    height: 4
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5589 22.9877H10.7664C10.4105 22.9877 10.1094 22.6864 10.1094 22.3304V20.3311C10.1094 19.9751 10.4105 19.6738 10.7664 19.6738H13.5863C13.9422 19.6738 14.2433 19.9751 14.2433 20.3311V22.3304C14.216 22.6864 13.9148 22.9877 13.5589 22.9877Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_789_29033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1094 21.3438H11.4782",
    stroke: "#03134F",
    strokeWidth: 0.342342,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3571 18.8794C28.1131 18.8794 28.726 18.2663 28.726 17.51C28.726 16.7537 28.1131 16.1406 27.3571 16.1406C26.6011 16.1406 25.9883 16.7537 25.9883 17.51C25.9883 18.2663 26.6011 18.8794 27.3571 18.8794Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4392 18.8794C26.1952 18.8794 26.808 18.2663 26.808 17.51C26.808 16.7537 26.1952 16.1406 25.4392 16.1406C24.6832 16.1406 24.0703 16.7537 24.0703 17.51C24.0703 18.2663 24.6832 18.8794 25.4392 18.8794Z",
    fill: "#FFC408"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.9883 17.5094C25.9883 17.8928 26.1525 18.2488 26.3989 18.4953C26.6453 18.2488 26.8096 17.8928 26.8096 17.5094C26.8096 17.126 26.6453 16.7699 26.3989 16.5234C26.1525 16.7699 25.9883 17.126 25.9883 17.5094Z",
    fill: "#03134F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3556 16.1406C26.9723 16.1406 26.6438 16.2776 26.3974 16.524C26.151 16.2776 25.8225 16.1406 25.4392 16.1406C24.6726 16.1406 24.0703 16.7431 24.0703 17.51C24.0703 18.2768 24.6726 18.8794 25.4392 18.8794C25.8225 18.8794 26.151 18.7424 26.3974 18.4959C26.6438 18.7424 26.9723 18.8794 27.3556 18.8794C28.1221 18.8794 28.7244 18.2768 28.7244 17.51C28.7244 16.7431 28.1221 16.1406 27.3556 16.1406Z",
    stroke: "#03134F",
    strokeWidth: 0.342342,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaymentCard);
export default __webpack_public_path__ + "static/media/iconPaymentCard.4942865fbb90c1ca67dcfc1ad9f0ccb1.svg";
export { ForwardRef as ReactComponent };